export const kernwissenTagsPaths = [
  { locale: 'de', path: 'kernwissen' },
  { locale: 'fr', path: 'comprendre-le-nucleaire' },
];
